function ShortKey() {}

let mapFunction = {}

ShortKey.install = function(Vue, options) {
    Vue.directive('shortkey', {
    // 当绑定元素插入到 DOM 中。
        bind: function(el, binding) {
            let shortArray = binding.value
            // console.log(binding)
            let input = el.querySelector('input')
            // let button = el.querySelector('button');
            let textArea = el.querySelector('textarea')
            if (input) {
                el = input
            } else if (textArea) {
                el = textArea
            }
            shortArray.forEach(item => {
                let short = item.toLocaleLowerCase()
                mapFunction['button-' + short] = {
                    shortKey: short,
                    element: el
                }
            })
        },
        unbind: function(el, binding) {
            let short = binding.value.join('-')
            delete mapFunction['button-' + short]
        }
    })

    document.addEventListener('keyup', function(event) {
        let target = event.target
        let nodeName = target.nodeName.toLocaleLowerCase()
        let flag = false
        if (nodeName === 'textarea') flag = true
        if (
            nodeName === 'input' &&
      target.type !== ('radio' || 'submit' || 'button' || 'checkbox' || 'reset')
        ) {
            flag = true
        }
        if (event.code && event.code.indexOf('Numpad') > -1) flag = true // 屏蔽全键盘，小键盘  触发
        // if (nodeName !== "input" && nodeName !== "textarea")
        if (!flag) {
            let key = event.key.toLocaleLowerCase()
            // ctrl + shift + alt + meta + code
            let keyCode = event.keyCode
            if (keyCode >= 30 && keyCode <= 122) {
                key = String.fromCharCode(keyCode).toLocaleLowerCase()
            } else if (keyCode === 13) {
                key = 'enter'
            }

            let otherKey = ''
            if (event.ctrlKey) {
                otherKey = 'ctrl-' + otherKey
            }
            if (event.shiftKey) {
                otherKey = 'shift-' + otherKey
            }
            if (event.altKey) {
                otherKey = 'alt-' + otherKey
            }
            if (event.metaKey) {
                otherKey = 'meta-' + otherKey
            }
            let mapKey = 'button-' + otherKey + key
            // console.log(key,mapKey, mapFunction)
            if (mapFunction[mapKey]) {
                let node = mapFunction[mapKey].element
                // console.log(node)
                if (node.nodeName.toLocaleLowerCase() === 'textarea') {
                    node.focus()
                } else {
                    // let e = document.createEvent('HTMLEvents');
                    // e.initEvent('click', true, true);
                    // e.keyType = key;
                    // node.dispatchEvent(e);
                    node.setAttribute('data-key', key)
                    node.click()
                }
            }
        }
    })
}

export default ShortKey



// WEBPACK FOOTER //
// ./src/common/js/ShortKey.js